import type { ActivityType } from '@/data/idp/interfaces';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';
import type { Course, CourseTypes } from '@/models/catalog/course';
import type { JobTitle } from '@/models/taxonomy/job';

export enum Goal {
  CareerDevelopment = 'career_development',
  CareerChange = 'career_change',
}

export enum Language {
  French = 'frances',
  English = 'ingles',
  Mandarin = 'mandarim',
  Spanish = 'espanhol',
  Italian = 'italiano',
  Japanese = 'japones',
  German = 'alemao',
  Korean = 'coreano',
  Portuguese = 'portugues_para_estrangeiros',
}

export enum Modalities {
  Hybrid = 'hibrido',
  Presencial = 'presencial',
  Distance = 'curso_a_distancia',
}

export enum Seniority {
  Analyst = 'analyst',
  Apprentice = 'apprentice',
  Assistant = 'assistant',
  Attendant = 'attendant',
  Auxiliary = 'auxiliary',
  Coordinator = 'coordinator',
  Director = 'director',
  Intern = 'intern',
  Manager = 'manager',
  Operator = 'operator',
  Specialist = 'specialist',
  Supervisor = 'supervisor',
  Technician = 'technician',
  VicePresident = 'vice_president',
}

export enum Scholarity {
  HighSchoolIncomplete = 'high_school_incomplete',
  HighSchoolComplete = 'high_school_complete',
  UndergraduateIncomplete = 'undergraduate_incomplete',
  UndergraduateComplete = 'undergraduate_complete',
  Postgraduate = 'postgraduate',
  Doctoral = 'doctoral',
}

export enum ProfileStepIds {
  PresentationWelcome = 'presentation_welcome',
  CurrentJob = 'current_job',
  Seniority = 'seniority',
  Goal = 'goal',
  DesiredJob = 'desired_job',
  Scholarity = 'scholarity',
  CourseTypes = 'course_types',
  Languages = 'languages',
  LocationInfo = 'location_info',
  NonResident = 'non_resident',
  ContactInfo = 'input_contact_email',
  PresentationFinished = 'presentation_finished',
}

export interface RecommendationProfile {
  id: number;
  current_step: ProfileStepIds;
  desired_job?: JobTitle | null;
  current_job?: JobTitle | null;
  goal?: Goal | null;
  non_resident?: boolean;
  address_city?: string | null;
  address_state?: string | null;
  languages?: Language[] | null;
  modalities?: Modalities[] | null;
  scholarity: Scholarity | null;
  seniority?: Seniority | null;
  course_types: CourseTypes[] | null;
  knowledge_areas?: KnowledgeArea[] | null;
  agreed_to_receive_emails: boolean | null;
  max_budget_per_month?: string | null;
  min_budget_per_month?: string | null;
  max_hours_available_per_week?: number | null;
  min_hours_available_per_week?: number | null;
  email?: string | null;
  phone?: string | null;
  completed_at: string | null;
}

export interface RecommendedActivity {
  id: string;
  name: string;
  reason: string;
  category: string;
  checksum: string;
  duration: {
    type: string;
    unit: number;
  };
  confidence: string;
  created_at: string;
  updated_at: string;
  course_type: CourseTypes;
  discarded_at: string;
  activity_type: ActivityType;
  activity_based_course: {
    catalog_courses: Course[];
  };
}
